module.exports = __webpack_public_path__ + "1970610b7ede7af9530a0b52af6c1381.webp";